import { newReconServiceAPI, newReconGetServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function editOperatorConfigService(payload) {
  const url = `${NEW_BASE_URL}/v1/config/updateConfigs`;
  return newReconServiceAPI(
    url,
    payload,
  );
}

export function fetchOperatorConfigDetails({
  operatorId,
}) {
  const url = `${NEW_BASE_URL}/v1/config/operatorConfigStatus?operatorId=${operatorId}`;
  return newReconGetServiceAPI(url);
}
